import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, Printer } from "lucide-react";

const wrap = "ti-dark -m-3 min-h-[calc(100vh-3rem)] w-full max-w-full overflow-x-hidden px-4 py-4 pb-28 sm:-m-5 sm:px-6 lg:-m-5 lg:-mb-5 lg:px-8 lg:py-5 lg:pb-6";
const Stat = ({ label, value, tone = "text-white" }) => (
  <div className="rounded-lg border border-white/8 bg-white/5 p-3"><div className="text-[10px] uppercase tracking-wider text-[#7E91AC]">{label}</div><div className={`mt-0.5 text-xl font-extrabold ${tone}`}>{value}</div></div>
);

export default function SecurityReports() {
  const [daily, setDaily] = useState(null);
  const [weekly, setWeekly] = useState(null);
  const load = useCallback(() => {
    api.get("/security/reports/daily").then((r) => setDaily(r.data)).catch(() => {});
    api.get("/security/reports/weekly").then((r) => setWeekly(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const exportCsv = async () => {
    try {
      const r = await api.get("/security/reports/export.csv", { responseType: "blob" });
      const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = `security_${daily?.date || "report"}.csv`; a.click(); URL.revokeObjectURL(u);
    } catch (e) {}
  };
  return (
    <div className={wrap} data-testid="security-reports-page">
      <div className="mx-auto w-full min-w-0 max-w-5xl">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h1 className="font-heading text-xl font-extrabold text-white">Laporan Security</h1>
          <div className="flex gap-2">
            <Button data-testid="export-csv-btn" onClick={exportCsv} className="h-9 bg-[#102544] text-xs hover:bg-[#163158]"><Download size={14} className="mr-1.5" />Excel/CSV</Button>
            <Button data-testid="print-btn" onClick={() => window.print()} className="h-9 bg-blue-600 text-xs hover:bg-blue-500"><Printer size={14} className="mr-1.5" />Cetak PDF</Button>
          </div>
        </div>
        <h2 className="mt-4 text-sm font-bold text-[#AAB8CC]">Harian · {daily?.date}</h2>
        <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-4">
          <Stat label="Security IN" value={daily?.security_in ?? "—"} tone="text-emerald-300" />
          <Stat label="Security OUT" value={daily?.security_out ?? "—"} tone="text-blue-300" />
          <Stat label="Admin IN" value={daily?.admin_in ?? "—"} />
          <Stat label="Tanpa Foto" value={daily?.no_photo ?? "—"} tone="text-amber-300" />
          <Stat label="Masih di Lokasi" value={daily?.open_stay ?? "—"} tone="text-blue-300" />
          <Stat label="Selesai" value={daily?.resolved ?? "—"} tone="text-emerald-300" />
          <Stat label="Belum Selesai" value={daily?.unresolved ?? "—"} tone="text-rose-300" />
        </div>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full text-xs text-[#C3D0E2]"><thead className="text-left text-[#7E91AC]"><tr><th className="p-2">No</th><th>Tipe</th><th>Nopol</th><th>WO</th><th>Waktu</th><th>Petugas</th><th>Foto</th><th>Status</th></tr></thead>
            <tbody>{(daily?.detail || []).map((d, i) => <tr key={i} className="border-t border-white/5"><td className="p-2 font-mono">{d.number}</td><td>{d.type}</td><td className="font-bold text-white">{d.plate}</td><td>{d.wo || "-"}</td><td>{d.time}</td><td>{d.officer}</td><td>{d.photos}</td><td>{d.status}</td></tr>)}</tbody>
          </table>
          {(daily?.detail || []).length === 0 && <p className="text-sm text-[#7E91AC]">Belum ada data hari ini.</p>}
        </div>
        <h2 className="mt-6 text-sm font-bold text-[#AAB8CC]">Mingguan · {weekly?.period}</h2>
        <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-4">
          <Stat label="Total IN" value={weekly?.security_in ?? "—"} tone="text-emerald-300" />
          <Stat label="Total OUT" value={weekly?.security_out ?? "—"} tone="text-blue-300" />
        </div>
        <div className="mt-2 ti-dcard p-3 text-[11px] text-[#C3D0E2]">
          <div className="font-semibold text-white">Per Kategori Temuan</div>
          <div className="mt-1 flex flex-wrap gap-2">{Object.entries(weekly?.by_category || {}).map(([k, v]) => <span key={k} className="rounded border border-white/10 bg-white/5 px-2 py-0.5">{k}: {v}</span>)}</div>
          <div className="mt-2 font-semibold text-white">Per Petugas</div>
          <div className="mt-1 flex flex-wrap gap-2">{Object.entries(weekly?.by_officer || {}).map(([k, v]) => <span key={k} className="rounded border border-white/10 bg-white/5 px-2 py-0.5">{k}: {v}</span>)}</div>
        </div>
      </div>
    </div>
  );
}
